import React, { Component } from 'react'
import { connect } from 'react-redux'
import { updateFillValue } from '../actions/index'
import Pikaday from 'pikaday'

class Date extends Component {
  componentDidMount() {
    var self = this
    this.picker = new Pikaday({
      field: document.getElementById('xmp_datepicker'),
      onSelect: function(date) {
        var dateValue = date.toISOString().replace(/T.*/,'')
        self.props.dispatch(updateFillValue(dateValue))
      },
      yearRange: 25,
    })
  }
  componentWillUnmount() {
    this.picker.destroy()
  }
  render() {
    return(
      <input type="text" id="xmp_datepicker" onKeyPress={() => false} />
    )
  }
}

const Container = connect(() => {return {}})(Date);

export default Container;



// WEBPACK FOOTER //
// ./src/components/Date.js